import ContentCopy from '@mui/icons-material/ContentCopy';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { CopyToClipboard } from '~components/CopyToClipboard/CopyToClipboard';
import Dialog from '~components/Dialog/Dialog';
import DialogActions from '~components/Dialog/DialogActions';
import DialogContent from '~components/Dialog/DialogContent';
import DialogHeader from '~components/Dialog/DialogHeader';
import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

interface ApiKeyDisplayDialogProps {
  isOpen: boolean;
  apiKey: string;
  clientName: string;
  onDone: () => void;
}

export default function ApiKeyDisplayDialog({
  isOpen,
  apiKey,
  clientName,
  onDone,
}: ApiKeyDisplayDialogProps) {
  return (
    <Dialog
      isOpen={isOpen}
      preventCloseOnBackdropClick
      preventCloseOnEscapeKeyDown
      maxWidth="sm"
    >
      <DialogHeader>{t('administration.api_clients.key_display_title')}</DialogHeader>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Alert severity="warning">
            {t('administration.api_clients.key_display_warning')}
          </Alert>

          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
            }}
          >
            {t('administration.api_clients.key_for', { name: clientName })}
          </Typography>

          <Card
            variant="outlined"
            sx={{
              p: 1,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Typography
              sx={{
                fontFamily: 'monospace',
                flexGrow: 1,
                textAlign: 'left',
                wordBreak: 'break-all',
              }}
            >
              {apiKey}
            </Typography>
            <CopyToClipboard
              textToCopy={apiKey}
              hideTextWhileCopying
              sx={{ width: 'fit-content' }}
            >
              <ContentCopy sx={{ fontSize: 16, color: 'text.secondary' }} />
            </CopyToClipboard>
          </Card>
        </Box>
      </DialogContent>
      <DialogActions>
        <SmallButton
          data-ui="page-settings-api-clients__key-display__done-button"
          onClick={onDone}
        >
          {t('administration.api_clients.done_button')}
        </SmallButton>
      </DialogActions>
    </Dialog>
  );
}
